(function () {
  'use strict';

  function normalizeText(value) {
    var text = String(value || '');

    if (typeof text.normalize === 'function') {
      text = text.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    }

    return text.toLocaleLowerCase();
  }

  function initBrandFilter(group) {
    var items = Array.prototype.slice.call(group.querySelectorAll('[data-brand-filter-item]'));
    var search = group.querySelector('[data-brand-filter-search]');
    var more = group.querySelector('[data-brand-filter-more]');
    var moreText = group.querySelector('[data-brand-filter-more-text]');
    var empty = group.querySelector('[data-brand-filter-empty]');
    var limit = Number(group.getAttribute('data-brand-filter-limit')) || 14;
    var expanded = false;

    if (!items.length) {
      return;
    }

    function isActive(item) {
      return Boolean(item.querySelector('.oj-filter-option.is-active'));
    }

    function render() {
      var query = normalizeText(search ? search.value : '');
      var matches = 0;
      var hiddenItems = 0;

      items.forEach(function (item, index) {
        var matchesQuery = !query || normalizeText(item.textContent).indexOf(query) !== -1;
        var shouldHide = !matchesQuery || (!query && !expanded && index >= limit && !isActive(item));

        if (matchesQuery) {
          matches += 1;
        }

        if (shouldHide) {
          hiddenItems += 1;
        }

        item.classList.toggle('is-hidden', shouldHide);
      });

      if (empty) {
        empty.hidden = matches !== 0;
      }

      if (more) {
        if (query || hiddenItems === 0 && !expanded) {
          more.hidden = Boolean(query) || hiddenItems === 0;
          return;
        }

        more.hidden = false;
        more.setAttribute('aria-expanded', String(expanded));

        if (moreText) {
          moreText.textContent = expanded
            ? more.getAttribute('data-brand-filter-less-label')
            : more.getAttribute('data-brand-filter-more-label') + ' ' + hiddenItems;
        }
      }
    }

    group.classList.add('is-enhanced');

    if (search) {
      search.addEventListener('input', render);
    }

    if (more) {
      more.addEventListener('click', function () {
        expanded = !expanded;
        render();
      });
    }

    render();
  }

  function initBrandFilters() {
    var groups = document.querySelectorAll('[data-brand-filter]');

    groups.forEach(initBrandFilter);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBrandFilters);
  } else {
    initBrandFilters();
  }
}());
